import { Types } from "@ioc/types";
import { IHttpService } from "@modules/infra/http/models/IHttpService";
import { IPaginatedResponse } from "@modules/infra/http/models/IPaginatedResponse";
import { IUser } from "@utils/interfaces";
import { inject, injectable } from "inversify";
import {
  IListUsersParams,
  IListUsersService,
} from "../models/IListUsersService";

@injectable()
export class ListUsersService implements IListUsersService {
  // @ts-ignore
  @inject(Types.IHttpService) private httpInstance: IHttpService;

  execute(params: IListUsersParams = {}): Promise<IPaginatedResponse<IUser>> {
    const { search, enabled, limit, offset } = params;
    return this.httpInstance.get<IPaginatedResponse<IUser>>("/users", {
      params: {
        search,
        enabled,
        limit,
        offset,
      },
    });
  }
}
